interface BillingQueueCardProps {
  count: number;
  total: number;
  onNavigate: () => void;
}

export default function BillingQueueCard({ count, total, onNavigate }: BillingQueueCardProps) {
  const formatCurrency = (val: number) =>
    new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(val);

  return (
    <div className="bg-white rounded-xl border border-background-200 overflow-hidden">
      <div className="px-5 py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-accent-50 flex items-center justify-center flex-shrink-0">
            <i className="ri-inbox-archive-line text-accent-600 text-xl"></i>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-foreground-900">Cola de Facturación</h3>
            <p className="text-xs text-foreground-500 mt-0.5">
              {count === 0
                ? 'Sin borradores pendientes de emisión'
                : `${count} borrador${count === 1 ? '' : 'es'} esperando folio fiscal`}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-5">
          <div className="text-right">
            <span className="text-[10px] uppercase tracking-wider text-foreground-500 font-semibold block">
              Monto acumulado
            </span>
            <span className={`text-lg font-bold ${count > 0 ? 'text-accent-700' : 'text-foreground-400'}`}>
              {formatCurrency(total)}
            </span>
          </div>
          <button
            onClick={onNavigate}
            disabled={count === 0}
            className="flex items-center gap-1.5 px-3 py-2 text-xs font-semibold text-white bg-accent-600 rounded-lg hover:bg-accent-700 cursor-pointer transition-colors whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-right-line"></i>
            Ir a Cobranza
          </button>
        </div>
      </div>
    </div>
  );
}